/**
 * Piletilevi report-api services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * All returns report for all sales, issued to promoter returns status 18 operations, excluding promoter issues excludes status 18 operations.
 */
export type SalespointReportPromoterScope = 'ALL' | 'ISSUED_TO_PROMOTER' | 'EXCLUDING_ISSUED_TO_PROMOTER';

export const SalespointReportPromoterScope = {
    All: 'ALL' as SalespointReportPromoterScope,
    IssuedToPromoter: 'ISSUED_TO_PROMOTER' as SalespointReportPromoterScope,
    ExcludingIssuedToPromoter: 'EXCLUDING_ISSUED_TO_PROMOTER' as SalespointReportPromoterScope
};

